"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var _styled_input_1 = require("../_styled-input");
exports.StyledInput = _styled_input_1.StyledInput;
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var _input_with_actions_1 = __importDefault(require("../_input-with-actions"));
var form_1 = __importDefault(require("../../molecules/form"));
var TextInput = function (props) {
    var defaultValue = props.defaultValue, placeholder = props.placeholder, readOnly = props.readOnly, restOfTheProps = __rest(props, ["defaultValue", "placeholder", "readOnly"]);
    if (props.masked) {
        var length_1 = props.defaultValue ? props.defaultValue.length : 8;
        placeholder = new Array(length_1).join('•');
        readOnly = true;
        defaultValue = null;
    }
    var Input = (React.createElement(form_1.default.Field.ContextConsumer, null, function (context) { return (React.createElement(TextInput.Element, __assign({}, automation_attribute_1.default('text-input'), { id: props.id || context.formFieldId, defaultValue: defaultValue, placeholder: placeholder, readOnly: readOnly }, restOfTheProps))); }));
    if (!props.actions.length) {
        return Input;
    }
    else {
        return (React.createElement(_input_with_actions_1.default, { actions: props.actions, size: props.size }, Input));
    }
};
TextInput.Element = styled_1.default(_styled_input_1.StyledInput)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n"], ["\n  height: ", ";\n"])), function (props) { return tokens_1.misc.input[props.size].height; });
TextInput.defaultProps = {
    readOnly: false,
    code: false,
    error: null,
    onChange: null,
    type: 'text',
    size: 'default',
    actions: []
};
exports.default = TextInput;
var templateObject_1;
//# sourceMappingURL=text-input.js.map